import { render } from "./Bom.vue?vue&type=template&id=591514c4&scoped=true"
import script from "./Bom.vue?vue&type=script&lang=js"
export * from "./Bom.vue?vue&type=script&lang=js"

import "./Bom.vue?vue&type=style&index=0&id=591514c4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591514c4"]])

export default __exports__